module.exports = __webpack_public_path__ + "img/[Emm].e59def10.svg";